'use client';

import { Image } from '@bytel/trilogy-react-ts';

export default function OtisBanner() {
    return (
        <div className='homeBanner'>
            <Image
                src='https://www.bouyguestelecom.fr/assets/media/original/image/CMS/ecommerce/byou/logo_Byou_white.svg'
                alt='B&you'
            />
        </div>
    );
}
